import React, { useEffect, useState } from "react";
import SideBarBack from "../../components/SidebarBack";
import { useDispatch } from "react-redux";
import {
  setDrawerActiveMenu,
  setIsDrawerActive,
} from "../../store/features/webUtilitiesSlice";
import mealPreferences from "../../assets/images/mealPreferences/mealPreferences.png";
import icon from "../../assets/images/mealPreferences/icon.png";
import Drawer from "react-modern-drawer";
import SpecificDiet from "./SpecificDiet";
import secureLocalStorage from "react-secure-storage";

export default function Menu() {
  const dispatch = useDispatch();
  const [isDrawerPopupOpen, setDrawerPopupOpen] = useState(false);

  const handleChangeSidebar = async (menu) => {
    await dispatch(setDrawerActiveMenu(menu));
    secureLocalStorage.removeItem("backMenu");
    if (menu && menu === 1) {
      secureLocalStorage.setItem("backMenu", "1");
    }
  };

  const handleCloseDrawer = async () => {
    await dispatch(setDrawerActiveMenu(31));
    await dispatch(setIsDrawerActive(false));
  };

  return (
    <>
      <div className="w-full h-full">
        <div className="w-full flex mb-2">
          <SideBarBack
            className="bg-transparent"
            handleCloseDrawer={handleCloseDrawer}
          />
        </div>
        <div className="flex flex-col gap-2 mt-24 w-11/12 mx-auto pb-10">
          <div className="cardbox w-full border border-gray-200 shadow-md py-5 px-6 rounded-3xl">
            <div className="mode1">
              <img
                className="watchImg w-24 h-24 rounded-md"
                alt="watchImg"
                src={mealPreferences}
              />
              <div>
                <p className="cardboxtitle text-sm">
                  Any ingredient allergies?
                </p>
                <p className="text-[11px]">
                  Get meals tailored to your needs and preferences.
                </p>
                <p
                  className="text-[#FF9950] cursor-pointer text-sm"
                  onClick={() => handleChangeSidebar(319)}
                >
                  Update
                </p>
              </div>
            </div>
          </div>

          <div className="cardbox text-center mt-28 relative w-full border border-[#FF9950] shadow-md py-4 pt-6 px-10 rounded-3xl">
            <img
              className="watchImg right-24 -top-20 w-28 h-28 absolute rounded-md"
              alt="watchImg"
              src={icon}
            />
            <div className="text-center">
              <p className="cardboxtitle text-sm">
                Are you currently following a specific dietary pattern ?
              </p>
              <p className="text-[11px]">
                Get meals tailored to your needs and preferences.
              </p>
              <p
                className="text-[#FF9950] cursor-pointer text-sm"
                onClick={() => handleChangeSidebar(318)}
              >
                Update
              </p>
            </div>
          </div>
        </div>
      </div>
      {/* <Drawer
        open={isDrawerPopupOpen}
        direction="right"
        lockBackgroundScroll={false}
        className={`manlay !p-5 !pb-10 sm:!w-96 !w-80 !overflow-y-scroll !overflow-x-hidden !rounded-l-3xl !border-none`}
        onClose={() => {
          setDrawerPopupOpen(false);
        }}
      >
        <SpecificDiet />
      </Drawer> */}
    </>
  );
}
